import { RequestFilterTypeEnum, RequestTypeEnum } from "@nlc/shared-types";

import type { RequestFilterType } from "../types/filters";

/**
 * Maps request filter types to corresponding request type enums
 */
export const getRequestTypes = (
  filter: RequestFilterType,
): RequestTypeEnum[] => {
  switch (filter) {
    case RequestFilterTypeEnum.GRAPHIC: {
      return [RequestTypeEnum.GRAPHIC];
    }
    case RequestFilterTypeEnum.VIDEO: {
      return [RequestTypeEnum.VIDEO];
    }
    case RequestFilterTypeEnum.WEBUI: {
      return [
        RequestTypeEnum.WEBSITE_DESIGN,
        RequestTypeEnum.WEBSITE_IMPLEMENTATION,
      ];
    }
    case RequestFilterTypeEnum.WEBSITE_DESIGN: {
      return [RequestTypeEnum.WEBSITE_DESIGN];
    }
    case RequestFilterTypeEnum.WEBSITE_IMPLEMENTATION: {
      return [RequestTypeEnum.WEBSITE_IMPLEMENTATION];
    }
    default: {
      return [
        RequestTypeEnum.GRAPHIC,
        RequestTypeEnum.VIDEO,
        RequestTypeEnum.WEBSITE_DESIGN,
        RequestTypeEnum.WEBSITE_IMPLEMENTATION,
      ];
    }
  }
};
